import { Link } from 'react-router-dom';
import Loading from '../../../../components/Loading';
import defaultimg from '../../../../assets/images/default.jpg'
import { changePictureSize } from '../../../../utils';
export default function List({ data, loading, navData }) {

    return (loading ? <Loading /> :
        <>

            <div className="list">
                {data?.records?.map((item, index) => {
                    let isguqin = ["唐琴", '宋琴', '元琴', '明琴', '清琴', '近现代琴']?.includes(item.channelName)
                    let isqinchannelNo = navData?.filter(a => { return a.channelNo === "Guqin" })?.[0]?.subChannel?.filter(a => { return a.channelName === item.channelName })?.[0]?.channelNo
                    let channelNo = navData?.filter(a => { return a.channelName === item.channelName })?.[0]?.channelNo
                    return (
                        <Link to={isguqin ? `/DigitalResourceLibrary/Guqin/${isqinchannelNo}/${item.id}` : `/DigitalResourceLibrary/${item.channelNo || channelNo}/${item.id}`} className="item" key={index}>
                            <div className="imgbox">
                                <img className={item.channelNo === 'Qinqu' ? "cover" : ""} src={item.imgSrc ? (window.ENV_IMG_PREURL + changePictureSize(item.imgSrc, 300)) : defaultimg} alt="" />
                            </div>
                            <div className="txt">
                                <p>{item?.title}</p>
                            </div>
                        </Link>
                    )
                })}
            </div>
        </>
    )
}
